export const registrationInitialStore = {
  status: '',
  errors: {}
};
